module.exports = __webpack_public_path__ + "static/media/chicken.668879cb.svg";